import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CreateAvtal from "../../../SkapaMote/Inputs/CreateAvtal";
import SelectAvtalProspekt from "../../../SkapaMote/Inputs/SelectAvtalProspekt";
import NyttBefintlig from "../../../SkapaMote/Inputs/NyttBefintlig";
import Affarsmojlighet from "../../../SkapaMote/Inputs/Affarsmojlighet";
import ProspektDeadline from "../../../SkapaMote/Inputs/ProspektDeadline";
import Divider from "@material-ui/core/Divider";
import TaggarComponent from 'components/TaggarComponent';
const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

function AvtalProspekt(props) {
    return (
        <div>
            <div style={{ paddingTop: '5px' }} className="row">
            <div className="col-12 my-2"  style={{ height: 'auto' }}>
                    <SelectAvtalProspekt
                    ListOfAVPro={props.ListOfAVPro}
                    AvtalId={props.Avtal}
                    selectedthisAvtalId={props.onchangeHanelAvtal}
                    />
                </div>
                {/*
                <div className="col-12 my-2"  style={{ height: 'auto' }}>
                    <CreateAvtal
                    Avtal={props.Avtal}
                    onchangeHanelAvtal={props.onchangeHanelAvtal}
                    />
                </div>
                */}
                {
                parseInt(props.Avtal) === 1?
                <div className="col-12 my-2"  style={{ height: 'auto' }}>
                   <Affarsmojlighet
                    Typ={props.AvtalType}
                    handleChange={props.onchangeHanelAvtalType}
                    />
                    <ProspektDeadline
                    ProspektDeadline={props.ProspektDeadline}
                    startDatetime={props.startDatetime}
                    handleChange={props.onchangeHanelProspektDeadline}
                    />
                </div>
                :""}
                <div className="col-12  my-1">
                 <Divider />
                </div>
                <div className="col-12 my-2"  style={{ height: 'auto' }}>
                <NyttBefintlig
                    nyttBefintlig={props.nyttBefintlig}
                    onchangeHanelAktivitet={props.onchangeHanelEvent}
                    />
                </div>
                <div className="col-12 my-1">
                 <Divider />
                </div>
                <div className="col-12 my-2"  style={{ height: 'auto' }}>
                <TaggarComponent onChange={props.onchangeTaggar} Source={2}/>
                </div>
            </div>
        </div>
    );
}

export default AvtalProspekt;